import { Component, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent } from 'src/app/core/widgets/grid/grid.component';
import { GridButton } from 'src/app/core/models/grid-button.model';
import { GridColumn } from 'src/app/core/models/grid-column.model';
import { GridSearchFilter } from 'src/app/core/models/grid-search-filter.model';
import { ModalService } from 'src/app/core/services/modal.service';
import { InspectionActionModalComponent, InspectionTarget } from '../../modals/inspection-action-modal/inspection-action-modal.component';
import { VehicleInspectionService } from '../../services/vehicle-inspection.service';
import { todayIso, ukDate } from '../../models/inspection.models';

/** Every vehicle inspection, with Mark done / Change due date / Remove. */
@Component({
    selector: 'app-inspections',
    templateUrl: './inspections.component.html',
    standalone: false
})
export class InspectionsComponent {
  @ViewChild(GridComponent) grid: GridComponent;
  @ViewChild(InspectionActionModalComponent) modal: InspectionActionModalComponent;

  target: InspectionTarget | null = null;
  mode: 'complete' | 'due' = 'complete';
  error: string = '';

  columns: GridColumn[] = [
    { active: true, label: 'Vehicle', field: 'vehicle.registration' } as GridColumn,
    { active: true, label: 'Inspection', field: 'inspectionType.name' } as GridColumn,
    { active: true, label: 'Next due', field: 'nextDueDate',
      value: (v) => v < todayIso() ? `<span class="text-danger"><strong>${ukDate(v)}</strong></span>` : ukDate(v) } as GridColumn,
    { active: true, label: 'Last done', field: 'lastDoneDate', value: (v) => ukDate(v) } as GridColumn,
    { active: true, label: 'Status', field: 'id',
      value: (v, r) => r.nextDueDate < todayIso() ? '<span class="badge badge-danger">Overdue</span>' : '<span class="badge badge-success">Due</span>' } as GridColumn,
  ];
  buttons: GridButton[] = [
    { label: '<i class="fas fa-check"></i> Mark done', type: 'btn-secondary', action: (b, r) => this.open(r, 'complete') } as GridButton,
    { label: '<i class="fas fa-calendar-day"></i> Change due', type: 'btn-secondary', action: (b, r) => this.open(r, 'due') } as GridButton,
    { label: '<i class="fas fa-trash"></i> Remove', type: 'btn-danger', action: (b, r) => this.remove(r) } as GridButton,
  ];
  searchFields: string[] = ['vehicle.registration', 'inspectionType.name'];
  searchFilters: GridSearchFilter[] = [
    { field: 'vehicle.registration', label: 'Vehicle' } as GridSearchFilter,
    { field: 'inspectionType.name', label: 'Inspection' } as GridSearchFilter,
    { field: 'nextDueDate', label: 'Next due', type: 'date' } as GridSearchFilter,
  ];

  constructor(private modalService: ModalService, private service: VehicleInspectionService) { }

  open(record: any, mode: 'complete' | 'due'): void {
    this.mode = mode;
    this.target = {
      id: record.id, registration: record.vehicle?.registration || ('Vehicle #' + record.vehicleId),
      typeName: record.inspectionType?.name || '', nextDueDate: record.nextDueDate, lastDoneDate: record.lastDoneDate,
    };
    setTimeout(() => {
      this.modal.reset();
      this.modalService.open('inspectionAction');
    });
  }

  remove(record: any): void {
    const name = (record.vehicle?.registration || 'this vehicle') + ' - ' + (record.inspectionType?.name || 'inspection');
    if (!confirm(`Remove ${name}? Its history is kept.`)) {
      return;
    }
    this.service.remove(record.id).pipe(take(1)).subscribe({
      next: () => this.refresh(),
      error: () => this.error = 'The inspection could not be removed. Please try again.',
    });
  }

  refresh(): void {
    this.grid.getRecordsForEntity();
  }
}
